import { LevelCourse } from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorPositionsAndTrainingPrograms/ProgramsManagement/types";
import { TLevel } from "~/pages/Editor/EditorCatalogEducationalPrograms/types";
import { FormStatus } from "~/shared/lib/statuses";

type UseAddCourseProps = {
  setCollectedData: any;
  addingCourse: LevelCourse;
  levelId: string;
};
const useAddCourse = ({
  setCollectedData,
  addingCourse,
  levelId,
}: UseAddCourseProps) => {
  const { course, status } = addingCourse;

  setCollectedData((prevState) => {
    const updatedLevels = prevState.levels.map((level: TLevel) => {
      if (level.id === levelId) {
        return {
          ...level,
          courses: [
            ...level.courses,
            {
              ...course,
              id: course.value,
              status: FormStatus[status.value],
              name: course.label,
              certificateValidityPeriod: course.certificateValidityPeriod,
            },
          ],
        };
      }
      return level;
    });

    return {
      ...prevState,
      levels: updatedLevels,
    };
  });
};

export default useAddCourse;
